import React from 'react'
import styled, { css } from 'styled-components'

import styles from './modal.module.css'

const ContainerDiv = styled.div`
background: linear-gradient(var(--brand-red), white, var(--brand-red));
width: 80%;
${props => props.small && css`
width: 70%;
`}
border-radius: 25px;
z-index: 10;
${props => !props.small && css`
height: 80%;
`}
min-width: 25%;
max-height: 80%;
padding-bottom: 3px;
position: relative;

@media screen and (min-width: 480px) {
    width: 60%;
    ${props => props.small && css`
    width: 50%;
    `}
}

@media screen and (min-width: 768px) {
    width: 30%;
    ${props => props.small && css`
    width: 25%;
    `}
}

@media only screen 
and (min-device-width: 768px) 
and (max-device-width: 1024px) 
and (orientation: portrait) {
    width: 50%;
    ${props => props.small && css`
    width: 45%;
    `}
}

@media only screen 
and (min-device-width: 1024px) 
and (max-device-width: 1024px) 
and (min-device-height: 1366px) 
and (max-device-height: 1366px) 
and (min-width: 1024px) 
and (max-width: 1024px) {
    width: 40%;
    ${props => props.small && css`
    width: 35%;
    `}
}

@media screen 
and (min-device-width: 1200px) 
and (max-device-width: 1600px) {
    width: 40%;
    ${props => props.small && css`
    width: 30%;
    `}
}

@media screen and (min-width: 1600px) {
    width: 15%;
    ${props => props.small && css`
    width: 10%;
    `}
}
`

const BodyContainerDiv = styled.div`
background-color: white;
border-radius: 10px;
border-bottom-left-radius: 22px;
border-bottom-right-radius: 22px;
padding: 5px;
margin-left: 3px;
margin-right: 3px;
${props => !props.small
        ? css`
        height: calc(100% - 40px);
        `
        : css`
        max-height: 50vh;
        `
    }
overflow-y: auto;
`

export const Modal = props => {
    return <div className={styles.backdrop}>
        <ContainerDiv {...props}>
            <div className={styles.modalHeader}>
                <div className={styles.modalHeading}>
                    {props.header}
                </div>
                <label onClick={props.close}>&times;</label>
            </div>
            <BodyContainerDiv {...props}>
                {props.children}
            </BodyContainerDiv>
        </ContainerDiv>
    </div>
}